export default __webpack_public_path__ + "static/media/value2.b7f65b95.png";